import React from 'react'

import { FormComponentProps } from '../../FormContainer/types'

import { PersonalInformationComponent } from './PersonalInformation.component'
import { PersonalInFormationFormValues } from './types'

export const PersonalInformationContainer: React.FC<
  FormComponentProps<PersonalInFormationFormValues>
> = ({ formData, setFormData }) => {
  return (
    <PersonalInformationComponent
      setFormData={setFormData}
      formData={formData}
    />
  )
}
